export default "__VITE_ASSET__b2968f93__"